import { useRef, useState, useEffect } from 'react'

import styles from './style.module.css'
import parse from '@src/helpers/parseHTML'
import ApplyButton from '@components/ApplyButton'
import ShareButtonRow from '@components/ShareButtonRow'
import { CoImage } from '@components/FeaturedJobs'
import { getApplicationLabels } from '@components/MobileApplicationCard'
import CloseCircle from '@assets/close-circle.svg'
import { renderDatePostedForPost } from '@src/helpers/jobsearch'

export default function SelectedJob({
  selected,
  selectedJob,
  setSelected,
  scrollToRef,
  scrollHeight,
  topRef,
  dashboardPage
}) {
  const theRef = useRef(null)
  const [loaded, setLoaded] = useState(false)
  const [imgFade, setImgFade] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setLoaded(true)
    }, 200)

    setTimeout(() => {
      setImgFade(true)
    }, 220)
  }, [])

  useEffect(() => {
    if (theRef?.current) {
      theRef.current.scrollTop = 0
    }
  }, [selected])

  let scrollStyle
  let headerStyle

  if (scrollHeight >= 120) {
    scrollStyle = {
      bottom: '18px',
    }
    headerStyle = {
      textAlign: 'start',
    }
  }

  if (!loaded) {
    return <LoadingModal />
  }

  const fadeStyle = {
    opacity: imgFade ? 1 : 0,
    transition: 'all .3s ease',
  }

  let customDescription
  if (selectedJob.scrapedSource === 'yc') {
    customDescription = styles.yc
  } else if (selectedJob.scrapedSource === 'remotiveio') {
    customDescription = styles.remotive
  }

  return (
    <div className={styles.container}>
      <div className={styles.jobDetails} ref={theRef}>
        <div
          className={`${styles.backToJobs} ${scroll ? styles.scroll : null}`}
          style={scrollStyle}
          onClick={() => {
            if (scrollToRef && topRef) {
              scrollToRef(topRef)
            }

            setSelected(-1)
          }}
        >
          <div className={styles.arrow} style={fadeStyle}>
            <CloseCircle />
          </div>
        </div>
        <div className={styles.logo} style={fadeStyle}>
          <div className={styles.imageWrapper}>
            <div>
              <CoImage job={selectedJob} height={60} width={60} />
            </div>
          </div>
          <div className={styles.jobCoText} style={headerStyle}>
            <h4>{`${selectedJob?.jobTitle}`}</h4>
            <h4 style={{ fontWeight: 'normal', paddingTop: '7px' }}>
              {selectedJob?.companyName}
            </h4>
          </div>
        </div>
      </div>
      <div className={styles.scrollBody} style={fadeStyle}>
        <div className={styles.datePosted}>
          {renderDatePostedForPost(selectedJob)}
        </div>
        <div className={styles.details}>
          {getApplicationLabels(selectedJob, false, true)}
        </div>
        <div className={`${styles.description} ${customDescription}`}>
          {renderDescription(selectedJob?.description)}
        </div>
        <div className={styles.shareLabel}>
          <b>Share this job!</b>
        </div>
        <div className={styles.shareWrapper}>
          <ShareButtonRow
            companyName={selectedJob?.companyName}
            jobTitle={selectedJob?.jobTitle}
            postUrl={`www.LifeShack.com/job/${selectedJob?.id}`}
            hideWhatsapp
            hideEmail
            hideReddit
          />
        </div>
      </div>
      <div className={styles.applyRow}>
        <ApplyButton job={selectedJob} applicationPage={dashboardPage} fluid />
      </div>
    </div>
  )
}

const renderDescription = (text) => {
  if (!text) return null

  if (text.indexOf('</') < 0) {
    return text
  }

  return parse(text)
}

function LoadingModal() {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setLoaded(true)
    }, 100)
  }, [])

  return (
    <div className={styles.container}>
      {loaded && <div className={styles.jobDetails}></div>}
      <div className={styles.scrollBody}></div>
    </div>
  )
}
